import React, {useContext, useEffect, useState} from 'react'
import ReactModal from "react-modal";
import {UserContext} from "./UserContext";
import axios from "axios";
import Image from "./Image";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import defaultImage from "./images/airplane.png";
import {formatDate, getBearerToken, getServerUrl} from "./utils/utils";
import {confirmAlert} from "react-confirm-alert";

function RankingListModal({isNew, rankingListType, isOpen, onClose, rankingListId}) {
    const {user} = useContext(UserContext)
    const [images, setImages] = useState([])
    const [trips, setTrips] = useState([])
    const [allTrips, setAllTrips] = useState([])
    const [rankingListSize, setRankingListSize] = useState(5)
    const [completedInitialSearch, setCompletedInitialSearch] = useState(false)
    const [searchValue, setSearchValue] = useState("")
    const [shouldSearch, setShouldSearch] = useState(false)
    const [selectedObject, setSelectedObject] = useState(null)
    const [rankingList, setRankingList] = useState([])
    const [listName, setListName] = useState("")

    const clearState = () => {
        setImages([])
        setRankingListSize(5)
        setCompletedInitialSearch(false)
        setSearchValue("")
        setShouldSearch(false)
        setSelectedObject(null)
        setRankingList([])
        setListName("")
    }

    const getPageTripIds = (index) => allTrips.sort((a,b) => new Date(b.startDate) - new Date(a.startDate))
        .slice(index * 12, allTrips.length <  index * 12 + 12 ? allTrips.length : index * 12 + 12)
        .map(trip => trip.id)

    const  retrieveTrips = async (index) => {
        const pageTripIds = getPageTripIds(index)
        axios.post(`${getServerUrl()}/trip/ids`, pageTripIds, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                Authorization: `Bearer ${await getBearerToken()}`,
            }
        }).then(response => {
            setTrips(response.data.sort((a, b) => new Date(b.startDate) - new Date(a.startDate)))
        });
    }

    const fetchTrips = async () => {
        axios.get(`${getServerUrl()}/user/${user?.id}/trip`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                const alphabeticalTrips = response.data
                    .sort((a, b) => a.name - b.name)
                setAllTrips(alphabeticalTrips)
            })
    }

    useEffect(() => {
        fetchTrips()
    }, [])

    useEffect(() => {
        if (shouldSearch) {
            if (rankingListType === 'trip') {
                searchForTrips(searchValue)
            } else {
                searchForImages(searchValue)
            }
            setShouldSearch(false)
        }
    }, [shouldSearch, searchValue])

    useEffect(() => {
        if (isOpen && rankingListType === 'image' && !completedInitialSearch) {
            searchForImages("")
            setCompletedInitialSearch(true)
        } else if (isOpen && rankingListType === 'trip') {
            retrieveTrips(0)
        }
    }, [isOpen, rankingListType, completedInitialSearch])

    useEffect(() => {
        if (isOpen && rankingListId) {
            retrieveSelectedRankingList(rankingListId)
        }
    }, [isOpen, rankingListType, rankingListId])

    const saveRankingList = async () => {
        const updatedRankingList = {
            id: rankingListId,
            rankingObjectIds: rankingList.sort((a, b) => a.ranking - b.ranking).map(rankingObject => {
                if (rankingListType === 'image') {
                    return rankingObject.image.id
                } else {
                    return rankingObject.trip.id
                }
            }),
            name: listName,
            type: rankingListType
        }

        if (rankingListId) {
            axios.put(`${getServerUrl()}/rankingList/${rankingListId}`, updatedRankingList, {
                headers: {
                    Authorization: `Bearer ${await getBearerToken()}`
                }
            }).then(res => {
                onClose(res.data)
                clearState()
            });
        } else {
            axios.post(`${getServerUrl()}/rankingList`, updatedRankingList, {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",
                    Authorization: `Bearer ${await getBearerToken()}`,
                }
            }).then(res => {
                updatedRankingList.rankingObjects = rankingList.sort((a, b) => a.ranking - b.ranking)
                updatedRankingList.id = res.data.id
                onClose(updatedRankingList)
                clearState()
            });
        }


    }

    const retrieveSelectedRankingList = async id => {
        axios.get(`${getServerUrl()}/rankingList/${id}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                const retrievedList = response.data.rankingObjects
                setRankingList(response.data.rankingObjects)
                if (retrievedList.length <= 5) {
                    setRankingListSize(5)
                } else if (retrievedList.length <= 10) {
                    setRankingListSize(10)
                } else {
                    setRankingListSize(25)
                }

                setListName(response.data.name)
            })
    }

    const searchForImages = async (searchValue) => {
        let updatedSearchValue = searchValue
        if (searchValue.includes(" (")) {
            updatedSearchValue = searchValue.split(" (")[0]
        }
        updatedSearchValue = updatedSearchValue.replace("/", "***")
        axios.get(`${getServerUrl()}/images/${updatedSearchValue ? updatedSearchValue : 'recent'}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setImages(response.data)
            })
    }

    const searchForTrips = async (searchValue) => {
        let updatedSearchValue = searchValue
        if (searchValue.includes(" (")) {
            updatedSearchValue = searchValue.split(" (")[0]
        }
        updatedSearchValue = updatedSearchValue.replace("/", "***")
        axios.get(`${getServerUrl()}/trips/${updatedSearchValue}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setTrips(response.data)
            })
    }

    const updateRankingsAfterSelection = index => {
        if (selectedObject) {
            const rankAlreadyTaken = rankingList.find(rankingObject => rankingObject.ranking === index + 1)
            let rankingListCopy = [...rankingList]
            const updatedRankingList = rankingList.sort((a, b) => a.ranking - b.ranking).map(rankingObjectToUpdate => {
                const updatedRankingObject = {...rankingObjectToUpdate}
                if (rankAlreadyTaken && rankingObjectToUpdate.ranking === index + 1) {
                    updatedRankingObject.ranking = updatedRankingObject.ranking + 1
                    rankingListCopy = [...rankingListCopy.filter(rankingObject => rankingObject.ranking !== index + 1), updatedRankingObject]
                } else if (rankAlreadyTaken && rankingObjectToUpdate.ranking > index + 1) {
                    const numRankingsBetweenObjectAndSelectedRanking = rankingListCopy.filter(rankingObject => {
                        return rankingObject.ranking > index + 1 && rankingObject.ranking <= updatedRankingObject.ranking
                    })
                    const everySpaceBeforeIsTaken = numRankingsBetweenObjectAndSelectedRanking.length >= rankingObjectToUpdate.ranking - (index + 1)
                    if (everySpaceBeforeIsTaken) {
                        updatedRankingObject.ranking = updatedRankingObject.ranking + 1
                        rankingListCopy = [...rankingListCopy.filter(rankingObject => rankingObject.ranking !== updatedRankingObject.ranking), updatedRankingObject]
                    }
                }
                return updatedRankingObject
            })
            const trimmedList = [...updatedRankingList].slice(0, rankingListSize - 1)
            trimmedList.push({
                ranking: index + 1,
                image: rankingListType === 'image' ? selectedObject : null,
                trip: rankingListType === 'trip' ? selectedObject : null,
            })
            setRankingList(trimmedList)
            setSelectedObject(null)
        }
    }

    const renderTripCard = (trip, isRankingCard) => {
        return (
            <div
                className="ranking-list-trip-card"
                onClick={() => {
                    if (!isRankingCard) {
                        setSelectedObject(trip)
                    }
                }}
                style={!isRankingCard && selectedObject?.id === trip.id ? {opacity: 0.5} : {}}

            >
                <div className="trip-profile-image"><img
                    src={trip?.trip_profile_image ? `${trip?.trip_profile_image}` : defaultImage}/>
                </div>
                <div>
                    <h4>{trip?.name}</h4>
                    <h5>{trip?.location}</h5>
                    <h6>{`${formatDate(trip?.startDate)} - ${formatDate(trip?.endDate)}`}</h6>
                </div>
            </div>
        )
    }

    const renderTrips = trips.map(trip => (
        <div style={{margin: 2, border: '2px solid black'}}>
            {renderTripCard(trip, false)}
        </div>
    ))

    const renderCurrentRankings = () => {
        if (isNew) {
            return Array.from(Array(rankingListSize).keys()).map((object, index) => {
                if (rankingListType === 'image') {
                    const imageRankingObject = rankingList.find(rankingObject => rankingObject.ranking === index + 1)
                    return (
                        <div className="ranking-object-container"
                             onClick={() => {
                                 if (selectedObject) {
                                     updateRankingsAfterSelection(index)
                                 } else {
                                     setSelectedObject(object)
                                 }
                             }}>
                            <div className="trip-list-number">
                                <div>{index + 1}</div>
                            </div>
                            {imageRankingObject && (
                                <Image
                                    imageFile={imageRankingObject.image}
                                    onClick={() => {
                                    }}
                                    imageIdsForNewActivity={[]}
                                    key={imageRankingObject.image.id}
                                    showVideoCoverImage={true}
                                />
                            )}
                        </div>
                    )
                } else {
                    const trip = rankingList.find(rankingObject => rankingObject.ranking === index + 1)?.trip
                    return (
                        <div className="ranking-object-container"
                             onClick={() => updateRankingsAfterSelection(index)}>
                            <div className="trip-list-number">
                                <div>{index + 1}</div>
                            </div>
                            {trip && renderTripCard(trip, true)}
                        </div>
                    )
                }
            })
        }
    }

    const deleteRankingList = async () => {
        axios.delete(`${getServerUrl()}/rankingList/${rankingListId}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        }).then(() => {
            onClose(rankingList, rankingListId, true)
            clearState()
        })
    }

    const confirmThenDeleteRankingList = () => {

        confirmAlert({
            title: 'Confirm Delete',
            message: 'Are you sure to delete this list?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteRankingList()
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    const confirmThenCloseModal = () => {


        confirmAlert({
            title: 'Confirm Delete',
            message: 'Are you sure to delete this list?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteRankingList()
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    const imageList = images.map(image => {
        return <Image
            imageFile={image}
            onClick={image => {
                setSelectedObject(image)
            }}
            imageIdsForNewActivity={[]}
            key={image.id}
            showVideoCoverImage={true}
            shouldBeOpaque={selectedObject?.id === image.id}
        />
    })


    return (
        <ReactModal isOpen={isOpen} className="ranking-list-modal">
            {isOpen && (
                <>
                    <div className="save-ranking-list-button">
                        <Button disabled={!listName} variant="contained" onClick={() => {
                            saveRankingList()
                        }
                        }>Save</Button>
                    </div>
                    <div className="ranking-list-name-size-container">
                        <TextField
                            label={listName ? "" : "Add the name of this list here..."}
                            onChange={(event) => {
                                setListName(event.target.value)
                            }}
                            value={listName}

                        />
                        <div className="ranking-list-size-container">
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Size</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={rankingListSize}
                                    label="List Size"
                                    onChange={e => setRankingListSize(e.target.value)}
                                >
                                    <MenuItem value={5}>Top 5</MenuItem>
                                    <MenuItem value={10}>Top 10</MenuItem>
                                    <MenuItem value={25}>Top 25</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="exit-ranking-list-button">
                        {rankingListId &&(
                            <Button variant="outlined" color="error"
                                onClick={() => confirmThenDeleteRankingList()}>Delete</Button>
                        )}
                        <CancelPresentationIcon sx={{fontSize: 40}} onClick={() => {
                            onClose()
                            clearState()
                        }}/>
                    </div>
                    <div className="ranking-list-modal-container">
                        <div className="ranking-list-container">
                            <div className="ranking-modal-info-container">
                                <Alert severity="info">To rank a photo: select your photo, then select its desired
                                    position.</Alert>
                            </div>
                            <div className="current-rankings">
                                {renderCurrentRankings()}
                            </div>
                        </div>
                        {rankingListType === 'image' && (
                            <div className="ranking-list-modal-images-container">
                                <div className="ranking-modal-info-container">
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        options={allTrips.map((trip) => `${trip.name} (${trip.location})`)}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Search for photos from your trip's names, locations, year or activities..."/>}
                                        onInputChange={(event, newInputValue) => {
                                            setSearchValue(newInputValue)
                                        }}
                                        inputValue={searchValue}
                                    />
                                    <Button variant="contained" onClick={() => setShouldSearch(true)}>Search</Button>
                                </div>
                                <div className="ranking-list-modal-images">
                                    {imageList}
                                </div>
                            </div>
                        )}
                        {rankingListType === 'trip' && (
                            <div className="ranking-list-modal-images-container">
                                <div className="ranking-modal-info-container">
                                    <Autocomplete
                                        id="free-solo-demo"
                                        freeSolo
                                        options={allTrips.map((trip) => `${trip.name} (${trip.location})`)}
                                        renderInput={(params) => <TextField {...params}
                                                                            label="Search for trips from your trip's by their name, location or year..."/>}
                                        onInputChange={(event, newInputValue) => {
                                            setSearchValue(newInputValue)
                                        }}
                                        inputValue={searchValue}
                                    />
                                    <Button variant="contained" onClick={() => setShouldSearch(true)}>Search</Button>
                                </div>
                                <div className="ranking-list-modal-images">
                                    {renderTrips}
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )}
        </ReactModal>
    )
}

export default RankingListModal;